import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";

const MyStatementsTab = Loadable(
  lazy(() =>
    import("./MyStatementsTab").then(({ MyStatementsTab }) => ({
      default: MyStatementsTab,
    }))
  )
);

export const myStatementsRoutes = [
  {
    path: `/my-statements`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <MyStatementsTab />
      </AuthorizedRoute>
    ),
  },
];
